import { useState } from "react";
import { ClickAwayListener, IconButton, Typography } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";
import { PersonAdd } from "@mui/icons-material";
import { T } from "components/util/t";

const useStyles = makeStyles((theme) => ({
    icon: {
        justifySelf: "center",
    },
    form: {
        gridColumn: "1/3",
        "& label": {
            display: "none",
        },
    },
    placeholder: {
        cursor: "pointer",
    },
    clickAwayHelper: {
        width: "100%",
    },
}));

export const TeamMembersPlaceholder = ({
    index,
    renderTeamMembersSelector,
}) => {
    const classes = useStyles();
    const [adding, setAdding] = useState(false);
    const toggleAdd = () => setAdding((adding) => !adding);
    const teamMembersSelector = renderTeamMembersSelector(index);

    if (!teamMembersSelector) return null;

    return adding ? (
        <div className={classes.form}>
            <ClickAwayListener onClickAway={toggleAdd}>
                <div className={classes.clickAwayHelper}>
                    {teamMembersSelector}
                </div>
            </ClickAwayListener>
        </div>
    ) : (
        <>
            <IconButton
                className={classes.icon}
                size="small"
                color="inherit"
                onClick={toggleAdd}
            >
                <PersonAdd />
            </IconButton>
            <Typography
                className={classes.placeholder}
                onClick={toggleAdd}
                variant="subtitle3"
            >
                <T x={index + 1}>athlete_x</T>
            </Typography>
        </>
    );
};
